import 'css/formDILookupResponsive.css';
import React, { useRef,Suspense,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT  } from "constants/variables";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import MenuItem  from "@mui/material/MenuItem"; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 

import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingNTs from "pages/forms/editOrNewFormDI/SortingTablesNTs";
import PropTypes from 'prop-types';

const initialFiltersNT= {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  numberNTFrom:"",
  numberNTTo:"",
  initDateFrom:null,
  initDateTo:null,
  endDateFrom:null,
  endDateTo:null,
  ori_tras_store_idFrom: "", 
  ori_tras_store_idTo: "", 
  dest_tras_store_idFrom:"",
  dest_tras_store_idTo:""  
};
 
const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": "",
  "name": ""
}];

const initialUserAccountToSelect = [{
  "id": "",
  "username":"",
  "firstName": "",
  "lastName1": "",
  "lastName2": "",
  "email": "",
  "aliasuser": ""
}];

const initialStateNT = [{
  "id" : 0,
  "ownformnt_id":0,
  "defaultStore_id" : 0,
  "tradename" : "",
  "useraccount_id" : 0,
  "username" :"",
  "number_nt":"",
  "init_date_nt":"",
  "end_date_nt":"",
  "opt_tras_store_id" : 0,
  "opt_tras_tradename" : "",
  "ori_tras_store_id" : 0,
  "ori_tras_tradename" : "",
  "dest_tras_store_id" : 0,
  "dest_tras_tradename" : "",
  "rel_trans_store_id" : 0,
  "rel_trans_tradename" : "",
  "codeler_code": "",
  "codeler_namees": "",
  "reatmenttypedestine_code": "",
  "treatmenttypedestine_namees": "",
  "processtypedestine_code": "",
  "processtypedestine_namees": "" 
}];
      
const SearchNTFilter = ({ showModalNTSettings, setShowModalNTSettings,setFormForm}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
  const [dataNT, setDataNT] = useState(initialStateNT);
  const [isLoadingErrorNT, setIsLoadingErrorNT] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [inputTextNT, setInputTextNT] = useState("");
  const [applyFiltersNT, setApplyFiltersNT]= useState(initialFiltersNT);
  const [filtersNT, setFiltersNT]= useState(initialFiltersNT);
  const [openEditFilterNT,setOpenEditFilterNT]= useState(false);
  const [errorsfiltersNT, setErrorsfiltersNT] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegNT,setNumTotRegNT]= useState(0);
  const [activeOffsetNT, setActiveOffsetNT]= useState(false);
  const [currencyOffsetNT, setCurrencyOffsetNT] = useState(0);
  const [rangeOffsetNT, setRangeOffsetNT] = useState([{}]); 
  const [storesToSelect,setStoresToSelect]= useState(initialStoresToSelect);
  const [userAccountsToSelect,setUserAccountsToSelect]= useState(initialUserAccountToSelect);
  const [oriTrasTradenameToSelect,setOriTrasTradenameToSelect]= useState(initialStoresToSelect); 
  const [destTrasTradenameToSelect,setDestTrasTradenameToSelect]= useState(initialStoresToSelect); 
  const [filteredOriTrasStoreFrom, setFilteredOriTrasStoreFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexOriTrasStoreFrom, setHighlightedIndexOriTrasStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredOriTrasStoreTo, setFilteredOriTrasStoreTo] = useState([]); // Opciones filtradas
  const [highlightedIndexOriTrasStoreTo, setHighlightedIndexOriTrasStoreTo] = useState(-1); // Índice de la opción resaltada
  const [filteredTransFrom, setFilteredTransFrom] = useState([]); // Opciones filtradas
  const [filteredDestTrasStoreTo, setFilteredDestTrasStoreTo] = useState(-1); // Índice de la opción resaltada 
  const [filteredTransTo, setFilteredTransTo] = useState([]); // Opciones filtradas
  const [highlightedIndexDestTrasStoreTo, setHighlightedIndexDestTrasStoreTo] = useState(-1); // Índice de la opción resaltada 
      
  const dispatch = useDispatch(); 
   
  const handleCloseDataEditNT = () => {
    setDataNT(initialStateNT);
    setIsLoadingErrorNT(false);
    setInputTextNT("");
    setApplyFiltersNT(initialFiltersNT);
    setFiltersNT(initialFiltersNT);
    setOpenEditFilterNT(false);
    setErrorsfiltersNT({});
    setNumTotRegFilter(0);
    setNumTotRegNT(0);
    setActiveOffsetNT(false);
    setCurrencyOffsetNT(0);
    setRangeOffsetNT([{}]); 
    setStoresToSelect(initialStoresToSelect);
    setUserAccountsToSelect(initialUserAccountToSelect); 
    setDestTrasTradenameToSelect(initialStoresToSelect);
    setOriTrasTradenameToSelect(initialStoresToSelect);
    setFilteredOriTrasStoreFrom([]);
    setHighlightedIndexOriTrasStoreFrom(-1); 
    setFilteredOriTrasStoreTo([]);  
    setHighlightedIndexOriTrasStoreTo(-1);  
    setFilteredTransFrom([]);
    setFilteredDestTrasStoreTo(-1);  
    setFilteredTransTo([]);
    setHighlightedIndexDestTrasStoreTo(-1);  
    setShowModalNTSettings(false)
	};

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };
  
  // Dentro del componente
  const debouncedHandleSearchOriTrasStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1);
      return;
    }
    const filtered = oriTrasTradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredOriTrasStoreFrom(filtered);
    setHighlightedIndexOriTrasStoreFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectOriTrasStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      ori_tras_store_idFrom: store.tradename || "",
      ori_tras_store_idTo: store.tradename || filtersNT.ori_tras_store_idTo 
    }));
    setFilteredOriTrasStoreFrom([]);
    setHighlightedIndexOriTrasStoreFrom(-1);
  }; 
  const handleKeyDownOriTrasStoreFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredOriTrasStoreFrom.length === 0 && filtersNT.ori_tras_store_idFrom.trim() === "") {
        setFilteredOriTrasStoreFrom(oriTrasTradenameToSelect);
        setHighlightedIndexOriTrasStoreFrom(0);
      } else {
        setHighlightedIndexOriTrasStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredOriTrasStoreFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexOriTrasStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasStoreFrom >= 0) {
      if (highlightedIndexOriTrasStoreFrom >= 0 && highlightedIndexOriTrasStoreFrom < filteredOriTrasStoreFrom.length) {
        handleSelectOriTrasStoreFrom(filteredOriTrasStoreFrom[highlightedIndexOriTrasStoreFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = oriTrasTradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.ori_tras_store_idFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersNT(filtersNT => ({
          ...filtersNT,
          ori_tras_store_idFrom: ""
        }));
      }
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchOriTrasStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredOriTrasStoreTo([]);
      setHighlightedIndexOriTrasStoreTo(-1);
      return;
    }
    const filtered = oriTrasTradenameToSelect
      .filter(store=>(store.tradename>=filtersNT.ori_tras_store_idFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredOriTrasStoreTo(filtered);
    setHighlightedIndexOriTrasStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectOriTrasStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
    ...filtersNT,
    ori_tras_store_idTo:  store.tradename || ""
  }));
  setFilteredOriTrasStoreTo([]);
  setHighlightedIndexOriTrasStoreTo(-1);
  }; 
  const handleKeyDownOriTrasStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredOriTrasStoreTo.length === 0 && filtersNT.ori_tras_store_idTo.trim() === "") {
        const filtered = oriTrasTradenameToSelect.filter(item=>(item.tradename>=filtersNT.ori_tras_store_idFrom));
        setFilteredOriTrasStoreTo(filtered);
        setHighlightedIndexOriTrasStoreTo(0);
      } else {
        setHighlightedIndexOriTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredOriTrasStoreTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexOriTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasStoreTo >= 0) {
      if (highlightedIndexOriTrasStoreTo >= 0 && highlightedIndexOriTrasStoreTo < filteredOriTrasStoreTo.length) {
        handleSelectOriTrasStoreTo(filteredOriTrasStoreTo[highlightedIndexOriTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = oriTrasTradenameToSelect
      .filter(item=>(item.tradename>=filtersNT.ori_tras_store_idFrom))
      .some((store) => {
      if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.ori_tras_store_idTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
    }); 
    if (!isValid) {
      setFiltersNT(filtersNT => ({
        ...filtersNT,
        ori_tras_store_idTo:  ""
      }));
    }
    setFilteredOriTrasStoreTo([]);
    setHighlightedIndexOriTrasStoreTo(-1);
    }
  };  

  // Dentro del componente
  const debouncedHandleSearchDestTrasStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTransFrom([]);
      setFilteredDestTrasStoreTo(-1);
      return;
    }
    const filtered = destTrasTradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredTransFrom(filtered);
    setFilteredDestTrasStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectDestTrasStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      dest_tras_store_idFrom: store.tradename || "",
      dest_tras_store_idTo: store.tradename || filtersNT.dest_tras_store_idTo,
    })); 
    setFilteredTransFrom([]);
    setFilteredDestTrasStoreTo(-1);
  }; 
  const handleKeyDownTransFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTransFrom.length === 0 && filtersNT.dest_tras_store_idFrom.trim() === "") {
        setFilteredTransFrom(destTrasTradenameToSelect);
        setFilteredDestTrasStoreTo(0);
      } else {
        setFilteredDestTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredTransFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setFilteredDestTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && filteredDestTrasStoreTo >= 0) {
      if (filteredDestTrasStoreTo >= 0 && filteredDestTrasStoreTo < filteredTransFrom.length) {
        handleSelectDestTrasStoreFrom(filteredTransFrom[filteredDestTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = destTrasTradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.dest_tras_store_idFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersNT(filtersNT => ({
          ...filtersNT,
          dest_tras_store_idFrom: "" 
        })); 
      }
      setFilteredTransFrom([]);
      setFilteredDestTrasStoreTo(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchDestTrasStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
      return;
    }
    const filtered = destTrasTradenameToSelect
      .filter(store=>(store.tradename>=filtersNT.dest_tras_store_idFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredTransTo(filtered);
    setHighlightedIndexDestTrasStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectDestTrasStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      dest_tras_store_idTo:store.tradename || ""
    })); 
    setFilteredTransTo([]);
    setHighlightedIndexDestTrasStoreTo(-1);
  }; 
  const handleKeyDownDesrTrasStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTransTo.length === 0 && filtersNT.dest_tras_store_idTo.trim() === "") {
        const filtered = destTrasTradenameToSelect.filter(item=>(item.tradename>=filtersNT.dest_tras_store_idFrom));
        setFilteredTransTo(filtered);
        setHighlightedIndexDestTrasStoreTo(0);
      } else {
        setHighlightedIndexDestTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredTransTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDestTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDestTrasStoreTo >= 0) {
      if (highlightedIndexDestTrasStoreTo >= 0 && highlightedIndexDestTrasStoreTo < filteredTransTo.length) {
        handleSelectDestTrasStoreTo(filteredTransTo[highlightedIndexDestTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = destTrasTradenameToSelect
      .filter(item=>(item.tradename>=filtersNT.dest_tras_store_idFrom))
      .some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.dest_tras_store_idTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersNT(filtersNT => ({
          ...filtersNT,
          dest_tras_store_idTo: ""
        }));
      }
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
    }
  };  

  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  
  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1); 
      setFilteredOriTrasStoreTo([]);  
      setHighlightedIndexOriTrasStoreTo(-1);   
      setFilteredTransFrom([]);
      setFilteredDestTrasStoreTo(-1); 
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
    }
  }, []); 

  const toggleDrawerSearchFormNT  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditNT();
    }
  };

  let inputHandlerNT = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextNT(lowerCase);
  };

  const openEditfiltersNT = () => {
    setFiltersNT(applyFiltersNT);
    setOpenEditFilterNT(!openEditFilterNT);
  };

  const toggleDrawerFilterEditNT = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditNT();
    }
  };

  const handleCancelfiltersNT = () => {
    setErrorsfiltersNT({});
    setFiltersNT(initialFiltersNT);
    setOpenEditFilterNT(!openEditFilterNT);
  };

  const handleChangeFilterEditNT = (e) => {
    const { name, value } = e.target;
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      [name]: value
    }));
  };

  const handleChangeSelectDateNT = (event) => {
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      initDateFrom: event!==null?new Date(event):null,
      initDateTo:null
    }));
  };

  const handleBlurSelectDateNTFrom = (e) => {
    handleChangeSelectDateNT(e);
    setErrorsfiltersNT(validateFormFilterNT());
  };

  const handleChangeSelectDateNTTo = (event) => {
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      initDateTo: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateNTTo = (e) => {
    handleChangeSelectDateNTTo(e);
    setErrorsfiltersNT(validateFormFilterNT());
  };
  
  const handleBlurFilterEditNT = (e) => {
    setErrorsfiltersNT(validateFormFilterNT());
  };
 
  const handleSubmitFilterEditNT = () => {
    setErrorsfiltersNT(validateFormFilterNT());
    if (Object.keys(errorsfiltersNT).length === 0) {
      setApplyFiltersNT(filtersNT);
      setFiltersNT(initialFiltersNT);
      setErrorsfiltersNT({});
      setOpenEditFilterNT(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeletefiltersNT = () => {
    setErrorsfiltersNT({});
    setFiltersNT(initialFiltersNT);
    setApplyFiltersNT(initialFiltersNT);
    setOpenEditFilterNT(!openEditFilterNT);
  };

  const validateFormFilterNT = () => {
    let errorsfiltersNT = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersNT.idFrom!=="" & !regexNumber.test(filtersNT.idFrom)) {
      errorsfiltersNT.idFrom = 'Text_TextNoNumber';
    }
    if (filtersNT.idTo!=="" & !regexNumber.test(filtersNT.idTo)) {
      errorsfiltersNT.idTo = 'Text_TextNoNumber';
    }
    if (filtersNT.idFrom!=="" & !errorsfiltersNT.idFrom!==undefined){
      if (filtersNT.idTo!=="" & !errorsfiltersNT.idTo!==undefined){
        if (parseInt(filtersNT.idTo)<parseInt(filtersNT.idFrom)){
          errorsfiltersNT.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (filtersNT.defaultStoreIdTo!=="" & filtersNT.defaultStoreIdTo<filtersNT.defaultStoreIdFrom){
      errorsfiltersNT.defaultStoreIdTo = 'Text_TextGreater_Store';
    }

    if (filtersNT.useraccountIdTo!=="" & filtersNT.useraccountIdTo<filtersNT.useraccountIdFrom){
      errorsfiltersNT.useraccountIdTo = 'Text_TextGreater_UserAccount';
    }

    if (regexInvalidCharacters.test(filtersNT.numberNTFrom)) {
      errorsfiltersNT.numberNTFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersNT.numberNTTo)) {
      errorsfiltersNT.numberNTTo = 'Text_TextNoValid';
    }

    if (filtersNT.numberNTTo!=="" & filtersNT.numberNTTo<filtersNT.numberNTFrom){
      errorsfiltersNT.numberNTTo = 'Text_TextGreater_numberNTTo';
    }

    if (filtersNT.initDateTo!==null & filtersNT.initDateTo<filtersNT.initDateFrom){
      errorsfiltersNT.initDateTo = 'Text_TextGreater_Date';
    }
    
    return errorsfiltersNT;
  }  

  const filtereddataNT = dataNT.filter((el) => {
    if (inputTextNT === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.number_nt || '');
      let result = dataTranslate.toLowerCase().includes(inputTextNT.toLowerCase());
      return result;
    }
  })

  useEffect(() => {
    let isMounted = true; 
    const fetchDataOriTras = async () => {
      try {
        const getData =
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master')))?
        await helpHttp().get8(ENDPOINT,`searchdcs/gelisttradenament`,token,"-1","-1"):
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master')))?
        await helpHttp().get8(ENDPOINT,`searchdcs/gelisttradenament`,token,defaultStore.id,"-1"):
        await helpHttp().get8(ENDPOINT,`searchdcs/gelisttradenament`,token,defaultStore.id,useraccount_id);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setOriTrasTradenameToSelect(getData); 
          
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  

    const fetchDataDestTras = async () => {
      try {
        const getData =
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master')))?
        await helpHttp().get8(ENDPOINT,`searchdcs/getlistdestinent`,token,"-1","-1"):
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master')))?
        await helpHttp().get8(ENDPOINT,`searchdcs/getlistdestinent`,token,defaultStore.id,"-1"):
        await helpHttp().get8(ENDPOINT,`searchdcs/getlistdestinent`,token,defaultStore.id,useraccount_id);
      if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDestTrasTradenameToSelect(getData); 
          
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   

    if (showModalNTSettings ) { 
      fetchDataOriTras();
      fetchDataDestTras();  
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,defaultStore.id,useraccount_id,openEditFilterNT,showModalNTSettings]);
    
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegNT = async () => {
      try {
        const getData  = (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master')))
        ? await helpHttp().get(ENDPOINT,`searchdcs/getinformationtablent`,token)
        : (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master'))?
            await helpHttp().get2(ENDPOINT,`searchdcs/getInformationtablentwithstore/`,token,defaultStore.id):
            await helpHttp().get8(ENDPOINT,`searchdcs/getInformationtablentwithstoreanduseraccount`,token,defaultStore.id,useraccount_id))
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataNT(initialStateNT);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }  
          }
        } else if (isMounted) {
          setNumTotRegNT(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = 
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master')))?
        await helpHttp().get3(ENDPOINT,`searchdcs/getcountfilternt`,token,"-1","-1",applyFiltersNT):
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master')))?
        await helpHttp().get3(ENDPOINT,`searchdcs/getcountfilternt`,token,defaultStore.id,"-1",applyFiltersNT):
        await helpHttp().get3(ENDPOINT,`searchdcs/getcountfilternt`,token,defaultStore.id,useraccount_id,applyFiltersNT);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataNT(initialStateNT);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } 
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    }; 

    const fetchDataStore = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`searchdcs/storesorderbytradename`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setStoresToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataUserAccount = async () => {
      try {
        const getData =(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master')))?
            await helpHttp().get2(ENDPOINT,`searchdcs/useraccountsorderbyusername/`,token,"-1"):
            await helpHttp().get2(ENDPOINT,`searchdcs/useraccountsorderbyusername/`,token,defaultStore.id);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setUserAccountsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  

    const fetchdataNT = async () => {
      setIsLoadingData(true);
      try {
        const getData = 
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master')))?
        await helpHttp().post7(ENDPOINT,`searchdcs/getformsnt`,token,currencyOffsetNT,LIMITPAGESIZE,"-1","-1",applyFiltersNT):
        (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master')))?
        await helpHttp().post7(ENDPOINT,`searchdcs/getformsnt`,token,currencyOffsetNT,LIMITPAGESIZE,defaultStore.id,"-1",applyFiltersNT):
        await helpHttp().post7(ENDPOINT,`searchdcs/getformsnt`,token,currencyOffsetNT,LIMITPAGESIZE,defaultStore.id,useraccount_id,applyFiltersNT);
        if (getData.err) {
          setIsLoadingData(false);
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataNT(getData);
          setIsLoadingData(false);
        }
      } catch (error) {
        setIsLoadingData(false);
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    
    if (showModalNTSettings){
      fetchnumTotRegNT();
      fetchnumTotRegFilter(); 
      fetchdataNT();
      if (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master'))){
        fetchDataStore();
      }
      if (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master'))){
        fetchDataUserAccount();
      } 
    }  
    return () => { isMounted = false };
  }, [t,i18n,token,roles,dispatch,LIMITPAGESIZE,applyFiltersNT,defaultStore.id,useraccount_id,currencyOffsetNT,showModalNTSettings]);

  return(
    <>
      {showModalNTSettings && 
        <div>
          <SwipeableDrawer
            PaperProps={{ className: "formdi-lookup-panel" }}
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormNT(false)}
            onOpen={toggleDrawerSearchFormNT(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'1300px', width: '1100px'}}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorNT?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_NT_Table')}
                  </h1>
                  <div>
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditNT}>{t('Button_Back')}</button><> </>
                  </div>
                </div>  
                <br/>
                <div className="formdi-pending-search">
                  <TextField autoComplete="off"
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextNT}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
                    placeholder={t('Text_FORM_Search')} 
                    onChange={inputHandlerNT}
                    fullWidth
                    label={t('Text_FORM_Search')}>
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV" className="formdi-pending-filters">
                  <button type="button" className="formdi-lookup-mobile-filter" onClick={openEditfiltersNT}>ESTABLECER FILTROS</button>
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                    <div className="formdi-pending-filters-row">
                      {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_NTs_Store_Master"))&&
                        <button type="button" className={`formdi-pending-chip ${applyFiltersNT.defaultStoreIdFrom !== "" || applyFiltersNT.defaultStoreIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                          <span className={`formdi-pending-dot ${ applyFiltersNT.defaultStoreIdFrom !== "" || applyFiltersNT.defaultStoreIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                          {t("Text_Store")}
                        </button>
                      }
                      {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_NTs_User_Master"))&&
                        <button type="button" className={`formdi-pending-chip ${applyFiltersNT.useraccountIdFrom !== "" || applyFiltersNT.useraccountIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                          <span className={`formdi-pending-dot ${ applyFiltersNT.useraccountIdFrom !== "" || applyFiltersNT.useraccountIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                          {t("Text_UserAccount")}
                        </button>
                      }
                      <button type="button" className={`formdi-pending-chip ${applyFiltersNT.numberNTFrom !== "" || applyFiltersNT.numberNTFrom !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                        <span className={`formdi-pending-dot ${ applyFiltersNT.numberNTFrom !== "" || applyFiltersNT.numberNTFrom !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_NT_NUMBER")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${(applyFiltersNT.initDateFrom!==null|| applyFiltersNT.initDateTo!==null) ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                        <span className={`formdi-pending-dot ${ (applyFiltersNT.initDateFrom!==null|| applyFiltersNT.initDateTo!==null)? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_NT_DATE")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${(applyFiltersNT.ori_tras_store_idFrom || applyFiltersNT.ori_tras_store_idTo || applyFiltersNT.dest_tras_store_idFrom || applyFiltersNT.dest_tras_store_idTo)  ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                        <span className={`formdi-pending-dot ${(applyFiltersNT.ori_tras_store_idFrom || applyFiltersNT.ori_tras_store_idTo || applyFiltersNT.dest_tras_store_idFrom || applyFiltersNT.dest_tras_store_idTo)? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Others_Filters")}
                      </button>
                  </div>
                </div>
                <br/>
                {!isLoadingData ?
                  <>
                    <div className="card shadow mb-4">    
                      <div className="card-body">
                        <TableSortingNTs
                          dataNT={filtereddataNT} 
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_NT_Table')}
                          showStoreNT={roles[0].listmenus.find((key)=>(key.name==='SubMenu_NT_View_Stores'))?true:false}
                          showUserAccountNT={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master'))?true:false}
                          numTotRegNT={numTotRegNT}
                          activeOffsetNT={activeOffsetNT}
                          rangeOffsetNT={rangeOffsetNT}
                          currencyOffsetNT={currencyOffsetNT}
                          setCurrencyOffsetNT={setCurrencyOffsetNT}
                          setFormForm={setFormForm}
                          handleCloseDataEditNT={handleCloseDataEditNT}
                        >
                        </TableSortingNTs>
                      </div>             
                    </div>
                    {openEditFilterNT &&
                      <div>
                      <SwipeableDrawer
            PaperProps={{ className: "formdi-lookup-panel" }}
                        anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditNT(false)}
                        onOpen={toggleDrawerFilterEditNT(true)}>
                        <Container >
                          <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form autoComplete="off" className="newfilterformstore" onSubmit={handleCancelfiltersNT}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_Store_Master'))   &&
                                    <>
                                      <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                                        <div className="form-group">
                                          <TextField autoComplete="off"
                                            id="defaultStoreIdFrom"
                                            name="defaultStoreIdFrom"
                                            value={filtersNT.defaultStoreIdFrom}
                                            inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                            label={errorsfiltersNT.defaultStoreIdFrom!=null?t(errorsfiltersNT.defaultStoreIdFrom):t('Text_Filter_Store_From')}
                                            placeholder={t('PlaceHolder_Filter_Store_From')}
                                            variant="outlined"
                                            onBlur={handleBlurFilterEditNT}
                                            onChange={handleChangeFilterEditNT}
                                            select
                                            SelectProps={{
                                            native: false, MenuProps: { PaperProps: { sx: { maxHeight: 320, borderRadius: '12px', '& .MuiMenuItem-root': { whiteSpace: 'normal', minHeight: 44 } } } },
                                            }}>
                                            <MenuItem key={0} value=""/>
                                            {storesToSelect.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.documentid+" - "+option.tradename}
                                                </MenuItem>
                                            ))}
                                          </TextField>
                                            
                                          <TextField autoComplete="off"
                                              id="defaultStoreIdTo"
                                              name="defaultStoreIdTo"
                                              value={filtersNT.defaultStoreIdTo}  
                                              inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                              label={errorsfiltersNT.defaultStoreIdTo!=null?t(errorsfiltersNT.defaultStoreIdTo):t('Text_Filter_Store_To')}
                                              placeholder={t('PlaceHolder_Filter_Store_to')}
                                              variant="outlined"
                                              onBlur={handleBlurFilterEditNT}
                                              onChange={handleChangeFilterEditNT}
                                              select
                                              SelectProps={{
                                              native: false, MenuProps: { PaperProps: { sx: { maxHeight: 320, borderRadius: '12px', '& .MuiMenuItem-root': { whiteSpace: 'normal', minHeight: 44 } } } },
                                              }}>
                                                <MenuItem key={0} value=""/>
                                              {storesToSelect.filter(item=>(item.id>=filtersNT.defaultStoreIdFrom)).map(option => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.documentid+" - "+option.tradename}
                                                </MenuItem>
                                              ))}
                                            </TextField>
                                          </div>
                                      </Suspense>
                                  </>
                                  }   
                                  { roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_NTs_User_Master'))   &&
                                    <>
                                      <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                                        <div className="form-group">
                                          <TextField autoComplete="off"
                                            id="useraccountIdFrom"
                                            name="useraccountIdFrom"
                                            value={filtersNT.useraccountIdFrom}
                                            inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                            label={errorsfiltersNT.useraccountIdFrom!=null?t(errorsfiltersNT.useraccountIdFrom):t('Text_Filter_UserAccount_From')}
                                            placeholder={t('PlaceHolder_UserAccount_From')}
                                            variant="outlined"
                                            onBlur={handleBlurFilterEditNT}
                                            onChange={handleChangeFilterEditNT}
                                            select
                                            SelectProps={{
                                            native: false, MenuProps: { PaperProps: { sx: { maxHeight: 320, borderRadius: '12px', '& .MuiMenuItem-root': { whiteSpace: 'normal', minHeight: 44 } } } },
                                            }}>
                                            <MenuItem key={0} value=""/>
                                            {userAccountsToSelect.map((option) => (
                                                <MenuItem key={option.id} value={option.username}>
                                                  {option.username+" - "+option.email}
                                                </MenuItem>
                                            ))}
                                          </TextField>
                                            
                                          <TextField autoComplete="off"
                                              id="useraccountIdTo"
                                              name="useraccountIdTo"
                                              value={filtersNT.useraccountIdTo}  
                                              inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                              label={errorsfiltersNT.useraccountIdTo!=null?t(errorsfiltersNT.useraccountIdTo):t('Text_Filter_UserAccount_To')}
                                              placeholder={t('PlaceHolder_UserAccount_To')}
                                              variant="outlined"
                                              onBlur={handleBlurFilterEditNT}
                                              onChange={handleChangeFilterEditNT}
                                              select
                                              SelectProps={{
                                              native: false, MenuProps: { PaperProps: { sx: { maxHeight: 320, borderRadius: '12px', '& .MuiMenuItem-root': { whiteSpace: 'normal', minHeight: 44 } } } },
                                              }}>
                                                <MenuItem key={0} value=""/>
                                              {userAccountsToSelect.filter(item=>(item.username>=filtersNT.useraccountIdFrom)).map(option => (
                                                <MenuItem key={option.id} value={option.username}>
                                                    {option.username+" - "+option.email}
                                                </MenuItem>
                                              ))}
                                            </TextField>
                                          </div>
                                      </Suspense>
                                  </>
                                  }  
                                  <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="numberNTFrom" 
                                      name="numberNTFrom"
                                      value={filtersNT.numberNTFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsfiltersNT.numberNTFrom!=null?t(errorsfiltersNT.numberNTFrom):t('Text_Filter_NumberNT_From')}
                                      placeholder={t('PlaceHolder_Filter_NumberNT_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditNT}
                                      onChange={handleChangeFilterEditNT}/>
                                     
                                    <TextField autoComplete="off"
                                      id="numberNTTo" 
                                      name="numberNTTo"
                                      value={filtersNT.numberNTTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsfiltersNT.numberNTTo!=null?t(errorsfiltersNT.numberNTTo):t('Text_Filter_NumberNT_To')}
                                      placeholder={t('PlaceHolder_Filter_NumberNT_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditNT}
                                      onChange={handleChangeFilterEditNT}/>
                                  </div>
                                
                                  <div className="form-group">
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                      <DesktopDatePicker
                                          id="initDateFrom" 
                                          name="initDateFrom"
                                          value={ filtersNT.initDateFrom!== null ? new Date(filtersNT.initDateFrom): null}
                                          format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                          label={errorsfiltersNT.initDateFrom!=null?t(errorsfiltersNT.initDateFrom):t('PlaceHolder_Filter_DateSheet_From')}
                                          onBlur={handleBlurSelectDateNTFrom}
                                          onChange={handleChangeSelectDateNT}
                                          slotProps={{
                                            textField: {
                                              placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                              sx: {
                                                color: '#1565c0',
                                                maxLength: '100',
                                                width: 430,  
                                                fontSize: '18px'
                                              },
                                              InputProps: {
                                                style: {
                                                  fontSize: '18px',
                                                }
                                              },
                                              InputLabelProps:{ 
                                                style: {
                                                  fontSize: '18px', 
                                                  background: '#FFFFFF'
                                                }
                                              },
                                            },
                                          }}
                                        />
                                      </LocalizationProvider>
                                       
                                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                        <DesktopDatePicker
                                          id="initDateTo" 
                                          name="initDateTo"
                                          minDate={filtersNT.initDateFrom!== null ? new Date(filtersNT.initDateFrom): null}
                                          value={ filtersNT.initDateTo!== null ? new Date(filtersNT.initDateTo): null}
                                          format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                          label={errorsfiltersNT.initDateTo!=null?t(errorsfiltersNT.initDateTo):t('PlaceHolder_Filter_DateSheet_To')}
                                          onBlur={handleBlurSelectDateNTTo}
                                          onChange={handleChangeSelectDateNTTo}
                                          slotProps={{
                                            textField: {
                                              placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                              sx: {
                                                color: '#1565c0',
                                                maxLength: '100',
                                                width: 430,  
                                                fontSize: '18px'
                                              },
                                              InputProps: {
                                                style: {
                                                  fontSize: '18px',
                                                }
                                              },
                                              InputLabelProps:{ 
                                                style: {
                                                  fontSize: '18px', 
                                                  background: '#FFFFFF'
                                                }
                                              },
                                            },
                                          }}
                                        />
                                      </LocalizationProvider>
                                  </div>   
                                  <div className="form-group">
                                    {/* Campo de texto para escribir y filtrar */}
                                    <span style={{ position: "relative" }}>
                                      <TextField autoComplete="off"
                                        id="ori_tras_store_idFrom"
                                        name="ori_tras_store_idFrom"
                                        value={filtersNT.ori_tras_store_idFrom}
                                        onChange={(e) => {
                                          setFiltersNT(prev => ({
                                            ...prev,
                                            ori_tras_store_idFrom: e.target.value.toUpperCase(),
                                            ori_tras_store_idTo: e.target.value.toUpperCase()
                                          }));
                                          debouncedHandleSearchOriTrasStoreFrom(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownOriTrasStoreFrom}
                                        onBlur={(event) => {
                                          if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                          }
                                        }}
                                        label={errorsfiltersNT.ori_tras_store_idFrom != null
                                          ? t(errorsfiltersNT.ori_tras_store_idFrom)
                                          : t('Text_Filter_OriTras_From')}
                                        placeholder={t('PlaceHolder_Filter_OriTras_From')}
                                        inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                        variant="outlined"
                                      />
                                      {filteredOriTrasStoreFrom.length > 0 && (
                                        <div
                                          className="dropdown-class"
                                          style={{
                                            position: "absolute",
                                            left: '0px',
                                            border: "2px solid #4e73df",
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "100%",
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa",
                                            zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()}
                                        >
                                          {filteredOriTrasStoreFrom.map((store, index) => (
                                            <MenuItem
                                              key={store.id}
                                              onClick={() => handleSelectOriTrasStoreFrom(store)}
                                              style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor: index === highlightedIndexOriTrasStoreFrom ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexOriTrasStoreFrom ? "white" : "black",
                                              }}
                                            >
                                              {store.documentid} - {store.tradename}
                                            </MenuItem>
                                          ))}
                                        </div>
                                      )} 
                                      </span>
                                        
                                      <span style={{ position: "relative" }} >
                                      <TextField autoComplete="off"
                                        id="ori_tras_store_idTo"
                                        name="ori_tras_store_idTo"
                                        value={filtersNT.ori_tras_store_idTo}
                                        onChange={(e) => {
                                          setFiltersNT(prev => ({
                                            ...prev,
                                            ori_tras_store_idTo: e.target.value.toUpperCase()
                                          }));
                                          debouncedHandleSearchOriTrasStoreTo(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownOriTrasStoreTo}
                                        onBlur={(event) => {
                                          if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                          }
                                        }}
                                        label={errorsfiltersNT.ori_tras_store_idTo != null
                                          ? t(errorsfiltersNT.ori_tras_store_idTo)
                                          : t('Text_Filter_OriTras_To')}
                                        placeholder={t('PlaceHoldert_Filter_OriTras_To')}
                                        inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                        variant="outlined"
                                      />
                                      {filteredOriTrasStoreTo.length > 0 && (
                                        <div
                                          className="dropdown-class"
                                          style={{
                                            position: "absolute",
                                            left: '0px',
                                            border: "2px solid #4e73df",
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "100%",
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa",
                                            zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()}
                                        >
                                          {filteredOriTrasStoreTo.map((store, index) => (
                                            <MenuItem
                                              key={store.id}
                                              onClick={() => handleSelectOriTrasStoreTo(store)}
                                              style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor: index === highlightedIndexOriTrasStoreTo ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexOriTrasStoreTo ? "white" : "black",
                                              }}
                                            >
                                              {store.documentid} - {store.tradename}
                                            </MenuItem>
                                          ))}
                                        </div>
                                      )}
                                    </span>
                                  </div> 
                                    
                                  <div className="form-group">
                                    <span style={{ position: "relative" }}>
                                    {/* Campo de texto para escribir y filtrar */}
                                      <TextField autoComplete="off"
                                        id="dest_tras_store_idFrom"
                                        name="dest_tras_store_idFrom"
                                        value={filtersNT.dest_tras_store_idFrom}
                                        onChange={(e) => {
                                          setFiltersNT(prev => ({
                                            ...prev,
                                            dest_tras_store_idFrom: e.target.value.toUpperCase(),
                                            dest_tras_store_idTo: e.target.value.toUpperCase()
                                          }));
                                          debouncedHandleSearchDestTrasStoreFrom(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownTransFrom}
                                        onBlur={(event) => {
                                          if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                          }
                                        }}
                                        label={errorsfiltersNT.dest_tras_store_idFrom != null
                                          ? t(errorsfiltersNT.dest_tras_store_idFrom)
                                          : t('Text_Filter_DestTras_From')}
                                        placeholder={t('PlaceHolder_Filter_DestTras_From')}
                                        inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                        variant="outlined"
                                      /> 
                                      {/* Desplegable dinámico */}
                                      {filteredTransFrom.length > 0 && (
                                        <div
                                          className="dropdown-class"
                                          style={{
                                            position: "absolute",
                                            left:'0px',
                                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "100%",
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa", // Fondo gris claro
                                            zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                        >
                                          {filteredTransFrom.map((store, index) => (
                                            <MenuItem
                                                key={store.id}
                                                onClick={() => handleSelectDestTrasStoreFrom(store)}
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "8px",
                                                    borderBottom: "1px solid #eee",
                                                    fontSize: '18px',
                                                    backgroundColor:
                                                    index === filteredDestTrasStoreTo ? "#4e73df" : "transparent",
                                                    color: index === filteredDestTrasStoreTo ? "white" : "black",
                                                }}
                                            >
                                              {store.documentid} - {store.tradename}
                                            </MenuItem>
                                          ))}
                                        </div>
                                      )}
                                      </span>
                                        
                                      <span style={{ position: "relative" }} >
                                        <TextField autoComplete="off"
                                          id="dest_tras_store_idTo"
                                          name="dest_tras_store_idTo"
                                          value={filtersNT.dest_tras_store_idTo}
                                          onChange={(e) => {
                                            setFiltersNT(prev => ({
                                              ...prev,
                                              dest_tras_store_idTo: e.target.value.toUpperCase() 
                                            }));
                                            debouncedHandleSearchDestTrasStoreTo(e.target.value);
                                          }}
                                          onKeyDown={handleKeyDownDesrTrasStoreTo}
                                          onBlur={(event) => {
                                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                              handleBlur();
                                            }
                                          }}
                                          label={errorsfiltersNT.dest_tras_store_idTo != null
                                            ? t(errorsfiltersNT.dest_tras_store_idTo)
                                            : t('Text_Filter_DestTras_To')}
                                          placeholder={t('PlaceHolder_Filter_DestTras_To')}
                                          inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                          InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                          variant="outlined"
                                        />  
                                        {/* Desplegable dinámico */}
                                        {filteredTransTo.length > 0 && (
                                          <div
                                            className="dropdown-class"
                                            style={{
                                              position: "absolute",
                                              left:'0px',
                                              border: "2px solid #4e73df", // Borde azul (#4e73df)
                                              borderRadius: "4px",
                                              marginTop: "4px",
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                              width: "100%",
                                              fontSize: '18px',
                                              backgroundColor: "#f8f9fa", // Fondo gris claro
                                              zIndex: 1000,
                                            }}
                                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                          >
                                          {filteredTransTo.map((store, index) => (
                                            <MenuItem
                                              key={store.id}
                                                onClick={() => handleSelectDestTrasStoreTo(store)}
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "8px",
                                                    borderBottom: "1px solid #eee",
                                                    fontSize: '18px',
                                                    backgroundColor:
                                                    index === highlightedIndexDestTrasStoreTo ? "#4e73df" : "transparent",
                                                    color: index === highlightedIndexDestTrasStoreTo ? "white" : "black",
                                                }}
                                              >
                                                {store.documentid} - {store.tradename}
                                              </MenuItem>
                                          ))}
                                        </div>
                                      )}
                                    </span>  
                                  </div>    
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditNT}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeletefiltersNT}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div> 
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }  
                  
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                } 
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

SearchNTFilter.propTypes = {
  showModalNTSettings: PropTypes.bool.isRequired,
  setShowModalNTSettings: PropTypes.func.isRequired,
  setFormForm: PropTypes.func.isRequired
};

export default SearchNTFilter;